export default class SupplyController {
  constructor(resource) {
    this._resource = resource;
  }

  async createSupplyByVehicleRequest(data) {
    try {
      let response = await this._resource(`refuel`).save(data);
      return response.body;
    } catch (error) {
      throw error;
    }
  }
  async getSupplyHistory() {
    try {
      let response = await this._resource(`refuel`).get();
      return response.body;
    } catch (error) {
      throw error;
    }
  }
  async getSupplyHistoryBetweenDates(begin, end) {
    try {
      let response = await this._resource(
        `refuel-between-dates/${begin}/${end}`
      ).get();
      return response.body;
    } catch (error) {
      throw error;
    }
  }
}
